import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/bankAccount'
import { getAccounts } from 'services'

const { BANK_ACCOUNT_REQUEST, BANK_ACCOUNT_SUCCESS, BANK_ACCOUNT_ERROR } = ACTION_TYPES

export function *getBankAccounts() {
  try {
    const response = yield call(getAccounts)
    yield put({ type: BANK_ACCOUNT_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: BANK_ACCOUNT_ERROR, payload: err })
  }
}

export default function *watchBankAccounts() {
  yield takeLatest(BANK_ACCOUNT_REQUEST, getBankAccounts)
}
